import { FC, useEffect } from 'react'
import ModalCard from 'components/ModalCard'
import useForm from 'hooks/useForm'
import { AxiosRequestConfig } from 'axios'
import useDataTableStore from 'store/dataTable'

interface Props {
  config: AxiosRequestConfig,
  title?: string,
  description?: string,
  altApiCall?: AxiosRequestConfig
}

const useModalForm = () => {
  const { Form, error, success, form } = useForm()
  const reload = useDataTableStore((state) => state.reload)

  useEffect(() => {
    if (success) reload()
  }, [success, reload])

  const ModalForm: FC<Props> = ({ children, config, title, description, altApiCall }) => (
    <>
      <ModalCard success={success} error={error} title={title || ""} description={description || ""}>
        <Form 
          {...config} 
          altApiCall={altApiCall}
        >
          {children}
        </Form>
      </ModalCard>
    </>
  )

  return { ModalForm, form }
}

export default useModalForm
